import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../components/ui/use-toast";
import { fetch } from "./fetch";

const editBookingEmail = async (
  body: {
    email: string;
    additionalEmails?: string[];
    force?: boolean;
  },
  bookingId: string,
) => {
  return fetch(`/api/bookings/${bookingId}/email`, "PATCH", body);
};

const editOfferEmail = async (
  body: {
    email: string;
    additionalEmails?: string[];
  },
  offerId: string,
) => {
  return fetch(`/api/offers/${offerId}/email`, "PATCH", body);
};

export const useBookingEditEmailMutation = (
  onOpenChange: (open: boolean) => void,
  setShowConfirmModal: (show: boolean) => void,
  bookingId?: string,
  offerId?: string,
) => {
  const queryClient = useQueryClient();
  const { toast, dismiss } = useToast();

  return useMutation({
    mutationFn: (data: { email: string; toastId: any; additionalEmails?: string[]; force?: boolean }) => {
      if (bookingId) return editBookingEmail(data, bookingId);
      if (offerId) return editOfferEmail(data, offerId);
      throw new Error("Booking ID or Offer ID is required");
    },
    onSuccess: (_, variables) => {
      dismiss(variables.toastId);
      toast({
        title: "Success",
        description: "Customer email updated successfully!",
        variant: "default",
      });

      if (bookingId) queryClient.invalidateQueries({ queryKey: ["bookingYachtOfferData", bookingId] });
      if (offerId) queryClient.invalidateQueries({ queryKey: ["usersData", offerId] });
      onOpenChange(false);
    },
    onError: (error: any, variables) => {
      dismiss(variables.toastId);
      if (error.message.includes("Primary email is already in use by another user.")) {
        setShowConfirmModal(true);
      } else {
        toast({
          title: "Error",
          description: error.message || "Failed to update customer email!",
          variant: "destructive",
        });
      }
    },
  });
};
